import React from "react";

type Props = {
    children: React.ReactNode;
    className?: string;
};

const WaveSection: React.FC<Props> = ({ children, className = "" }) => {
    return (
        <div className={`relative bg-green-200 ${className}`}>

            {/* Top Wave */}
            <div className="absolute top-0 left-0 w-full overflow-hidden leading-none">
                <svg
                    viewBox="0 0 1440 120"
                    className="w-full h-16"
                    preserveAspectRatio="none"
                >
                    <path
                        d="
      M0,60 
      C120,100 240,20 360,60 
      C480,100 600,20 720,60 
      C840,100 960,20 1080,60 
      C1200,100 1320,20 1440,60 
      L1440,0 L0,0 Z
    "
                        fill="#ffffff"
                    />
                </svg>
            </div>

            {/* Content */}
            <div className="relative pt-14 pb-20">
                {children}
            </div>

            {/* Bottom Wave */}
            <div className="absolute bottom-0 left-0 w-full overflow-hidden leading-none rotate-180">
                <svg
                    viewBox="0 0 1440 120"
                    className="w-full h-16"
                    preserveAspectRatio="none"
                >
                    <path
                        d="
      M0,60 
      C120,100 240,20 360,60 
      C480,100 600,20 720,60 
      C840,100 960,20 1080,60 
      C1200,100 1320,20 1440,60 
      L1440,0 L0,0 Z
    "
                        fill="#ffffff"
                    />
                </svg>
            </div>
        </div>
    );
};

export default WaveSection;